export type Cart = {
    attributes: Record<string, unknown>;
    cart_level_discount_applications: DiscountApplication[];
    currency: string;
    item_count: number;
    items: CartItem[];
    items_subtotal_price: number;
    note: string | null;
    original_total_price: number;
    requires_shipping: boolean;
    token: string | null;
    total_discount: number;
    total_price: number;
    total_weight: number;
};

export type DiscountApplication = {
    type: "automatic" | "manual";
    key: string;
    title: string;
    description: string;
    value: string;
    created_at: string;
    value_type: "percentage";
    allocation_method: string;
    target_selection: string;
    target_type: string;
    total_allocated_amount: number;
};

export type CartItem = {
    collections: string[];
    id: number;
    properties: Record<string, unknown>;
    quantity: number;
    variant_id: number;
    key: string;
    title: string;
    price: number;
    original_price: number;
    discounted_price: number;
    line_price: number;
    original_line_price: number;
    total_discount: number;
    discounts: Discount[];
    sku: string;
    grams: number;
    vendor: string;
    taxable: boolean;
    product_id: number;
    product_has_only_default_variant: boolean;
    gift_card: boolean;
    final_price: number;
    final_line_price: number;
    url: string;
    featured_image: FeaturedImage;
    image: string;
    handle: string;
    requires_shipping: boolean;
    product_type: string;
    product_title: string;
    product_description: string;
    variant_title: string;
    variant_options: string[];
    options_with_values: OptionsWithValue[];
    line_level_discount_allocations: DiscountAllocation[];
    line_level_total_discount: number;
    quantity_rule: QuantityRule;
    has_components: boolean;
    selling_plan_allocation: SellingPlanAllocation;
    tags: string[];
};

export type Discount = {
    amount: number;
    title: string;
};

export type FeaturedImage = {
    aspect_ratio: number;
    alt: string;
    height: number;
    url: string;
    width: number;
};

export type OptionsWithValue = {
    name: string;
    value: string;
};

export type DiscountAllocation = {
    amount: number;
    discount_application: DiscountApplication;
};

export type QuantityRule = {
    min: number | null;
    max: number | null;
    increment: number;
};

export type SellingPlanAllocation = {
    price_adjustments: PriceAdjustment[];
    price: number;
    compare_at_price: number;
    per_delivery_price: number;
    selling_plan: SellingPlan;
};

export type PriceAdjustment = {
    position: number;
    price: number;
};

export type SellingPlan = {
    id: number;
    name: string;
    description: string | null;
    options: Option[];
    recurring_deliveries: boolean;
    fixed_selling_plan: boolean;
    price_adjustments: SellingPlanPriceAdjustment[];
};

export type Option = {
    name: string;
    position: number;
    value: string;
};

export type SellingPlanPriceAdjustment = {
    order_count: number | null;
    position: number;
    value_type: string;
    value: number;
};

export type LineItem = {
    id: number;
    quantity: number;
    properties?: Record<string, unknown>;
};

export type CartCallback = (cart: Cart) => void;

export type CartChangePayload =
    | {
          id: number | string;
          quantity: number;
      }
    | {
          line: number;
          quantity: number;
      };

export type CartUpdatePayload = {
    updates?: Record<number, number>;
    note?: string;
    attributes?: {
        [k: string]: string | number | boolean | File;
    };
};

export enum GWPTypes {
    buy_x_get_y = "buy_x_get_y",
    buy_x_of_y_get_z = "buy_x_of_y_get_z",
    spend_x_get_y = "spend_x_get_y",
    spend_x_of_y_get_z = "spend_x_of_y_get_z",
}

export type GWPPromotion = {
    id: number;
    type:
        | GWPTypes.spend_x_get_y
        | GWPTypes.spend_x_of_y_get_z
        | GWPTypes.buy_x_get_y
        | GWPTypes.buy_x_of_y_get_z;
    title: string;
    qualifier_product_tag?: string;
    qualifier_product_quantity: number;
    qualifier_product_collection?: string;
    qualifier_cart_value?: number;
    hide_gwp_in_cart: boolean;
    gift_image: string;
    gift_title: string;
    gift_id: string;
};
